"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ACCEPTED: 'Accepted',
    ACCEPTED_CONDITIONAL_OFFER: 'Accepted with Conditional offer',
    ACCEPTED_UNCONDITIONAL_OFFER: 'Accepted with Unconditional offer',
    ALTERNATE_ADMISSION: 'Alternate admission',
    DEFERRED: 'Deferred',
    MATRICULATION_SCHOOL: 'Matriculation School',
    REJECTED: 'Rejected',
    WAITLISTED: 'Waitlisted',
    APPLICATION_WITHDRAWN: 'Application Withdrawn',
    FOUNDATION_YEAR_OFFER: 'Foundation Year Offer',
    NO_RESPONESES: 'No Responses',
    ACCEPTED_ED_ELSEWHERE: 'Accepted ED Elsewhere',
};
//# sourceMappingURL=applicationStatus.js.map